export default __webpack_public_path__ + "day-one-info-rocket.e5d25b17.svg";